import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FwcHeaderPage } from '../../../../fwc-lib.js';
import { Router } from '@angular/router';
import { UserCacheService } from '../../services/user-cache.service';
import { DataService } from '../../services/data.service';
import { AppConstants } from '../../constants/app-constants';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sae-page-header',
    templateUrl: './page-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageHeaderComponent implements OnDestroy {
  @Input() pageTitle: string;
  @Input() breadcrumbs: any;
  @Input() subTitle: string;
  @Input() universityHeader = true;
  participantId: number = null;
  universityName: string = null;
  participationLabel: string = null;

  mockCrumbs = [
    {
      label: 'Back To Dashboard',
      path: '/secure/dashboard',
      active: false
    },
    {
      label: 'Tutorials',
      path: 'tutorials',
      active: true
    }
  ];
  private ds: Subscription;

  constructor( public userCacheService: UserCacheService, public router: Router, public dataService: DataService){
    const fwcHeaderPage = new FwcHeaderPage();
    fwcHeaderPage.build();
    this.participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
    this.universityName = this.userCacheService.getUserData(AppConstants.UNIVERSITY_NAME);
    this.participationLabel = this.userCacheService.getUserData(AppConstants.PARTICIPATION_LABEL);
    this.ds = dataService.announcement.subscribe(announce => {
      if (announce != null) { 
        if (announce.topic === AppConstants.PARTICIPATION_ID) {
          this.participantId = announce.message;
        }
        if (announce.topic === AppConstants.UNIVERSITY_NAME) {
          this.universityName = announce.message;
        }
        if (announce.topic === AppConstants.PARTICIPATION_LABEL) {
          this.participationLabel = announce.message;
        }
      }
    });
  }
  navigateTo(path: string): void {
    path = path.replace('__PARTICIPATION_ID__', this.participantId.toString());
    this.router.navigate([path]);
  }
  ngOnDestroy(): void {
    if (this.ds) {
      this.ds.unsubscribe();
    }
  }
}
